import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddEngagementComponent } from './add-engagement.component';

const routes: Routes = [
  {
    path: '',
    component: AddEngagementComponent,
    data: { Title: 'Add Engagement' }// canActivate: [RouteGuard]
  }
];

@NgModule({

  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class AddEngagementRoutingModule { }
